import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { SpinnerService } from './spinner.service';
import { AsyncPipe, NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [NgIf, MatProgressSpinner, RouterOutlet, AsyncPipe],
})
export class AppComponent implements OnInit {
  title: string = 'forgot-password';
  flag: boolean = false;
  loading$!: Observable<boolean>;

  constructor(private spinnerService: SpinnerService) {}

  ngOnInit(): void {
    this.loading$ = this.spinnerService.isLoading$;
  }
}
